import { Slide } from '@/components/core/Slide';
import audioFile from './81-future-thoughts-2.mp3';

const transcript = `
  Weet je zeker dat ik het hierover kan hebben, Jonathan? Omdat we hier al vaak uitgebreid over 
  gesproken hebben en analyses hebben uitgewerkt.
`;

export const slide = () => {
  return (
    <Slide notes={transcript} audio={audioFile} visualizer="full" transition="fade">
      <div className="absolute inset-0 z-0 flex items-center justify-center"></div>
    </Slide>
  );
};
